module.exports = __webpack_public_path__ + "static/media/blue_icon.82c07bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue_icon.png
// module id = 1141
// module chunks = 3